export const SELECT_POPOVERS_ALIGNMENTS = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
}
